import { render, staticRenderFns } from "./successPage.vue?vue&type=template&id=2ba6b59d&scoped=true&"
import script from "./successPage.vue?vue&type=script&lang=js&"
export * from "./successPage.vue?vue&type=script&lang=js&"
import style0 from "./successPage.vue?vue&type=style&index=0&id=2ba6b59d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba6b59d",
  null
  
)

export default component.exports